
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order",
      function () {
        return require("private-next-pages/order/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order"])
      });
    }
  